<youtube-player [videoId]="videoId" width="800" [playerVars]="{loop: 1, playlist: videoId, rel:0, showinfo:0}"></youtube-player>
